import { render, staticRenderFns } from "./message-custom.vue?vue&type=template&id=1cf99f92&scoped=true"
import script from "./message-custom.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-custom.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-custom.vue?vue&type=style&index=0&id=1cf99f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf99f92",
  null
  
)

export default component.exports